interface SearchableUser {
  name?: string;
  email?: string;
}

const filterBySearch = <T extends SearchableUser>(string: string, data: T[]): T[] => {
  return data.filter((user) => {
    if (!user.name) return false
    const nameMatch = user.name.toLowerCase().startsWith(string.toLowerCase())

    // Leave search by email incase i want to  add it later
    // const emailMatch = user.email.toLowerCase().includes(string.toLowerCase())
    return nameMatch
  })
}
export default filterBySearch